import { Controller } from '@hotwired/stimulus';
import { useMatchMedia } from 'stimulus-use';

export default class extends Controller {
  initialize() {}

  connect() {
    useMatchMedia(this, {
      mediaQueries: {
        mobile: '(max-width: 768px)',
      },
    });
    this.isMobile = window.matchMedia('(max-width: 768px)').matches;
    if (this.isMobile) {
      this.closeAll();
    } else {
      this.openAll();
    }
  }

  static targets = ['trigger', 'label', 'content', 'icon'];
  static values = {
    isOpen: Boolean,
  };

  mobileChanged({ name, media, matches, event }) {
    this.isMobile = matches;
    if (matches) {
      this.closeAll();
    } else {
      this.openAll();
    }
  }

  setOpenValue() {
    this.isOpenValue = !this.isOpenValue;
  }

  toggle(e) {
    this.setOpenValue();
    this.toggleIcon();
    this.toggleContent();
    this.toggleTrigger();
  }
  closeAll() {
    this.isOpenValue = false;
    this.toggleIcon();
    this.toggleContent();
    this.toggleTrigger();
  }
  openAll() {
    this.isOpenValue = true;
    this.toggleIcon();
    this.toggleContent();
    this.toggleTrigger();
  }

  toggleIcon() {
    this.iconTarget.classList.toggle('rotate-180', !this.isOpenValue);
  }

  toggleContent() {
    this.contentTarget.classList.toggle('hidden', !this.isOpenValue);
  }

  toggleTrigger() {
    this.triggerTarget.classList.toggle('hidden', this.isOpenValue);
    this.triggerTarget.setAttribute(
      'aria-expanded',
      this.isOpenValue
    );
  }
}
